module.exports = __webpack_public_path__ + "img/web.2c2db798.svg";